module.exports = __webpack_public_path__ + "img/9-fourImg.eae18799.png";